import { render, staticRenderFns } from "./SelectTruckModal.vue?vue&type=template&id=35b42de0&scoped=true"
import script from "./SelectTruckModal.vue?vue&type=script&lang=js"
export * from "./SelectTruckModal.vue?vue&type=script&lang=js"
import style0 from "./SelectTruckModal.vue?vue&type=style&index=0&id=35b42de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b42de0",
  null
  
)

export default component.exports